import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AiAgentResponse } from '../../../models/responses/ai-agent-response';
import { WhiteLabelService } from '../../../services/white-label.service';
import { handleErrors } from '../../../utilities/error-handler-utils';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-upload-logo',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    NgIf
  ],
  templateUrl: './upload-logo.component.html',
  styleUrl: './upload-logo.component.scss'
})
export class UploadLogoComponent {
  errorMessage: string | undefined = undefined;
  isLoading: boolean = false;
  fileSet: boolean = false;
  file_store!: FileList;
  file_list: Array<string> = [];

  constructor(
    public dialogRef: MatDialogRef<UploadLogoComponent>,
    private snackBar: MatSnackBar,
    private whiteLabelService: WhiteLabelService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {

  }

  handleFileInputChange(l: FileList) {
    this.file_store = l;
    this.fileSet = this.file_store.length > 0;
  }

  onSubmitForm() {
    const formData = this.getFileData();

    if (formData) {
      this.whiteLabelService.addLogo(formData).subscribe({
        next: () => {
          this.isLoading = false;
          this.snackBar.open('Logo added', 'Close', { duration: 5000 })
          this.dialogRef.close()
        },
        error: (error) => {
          this.errorMessage = handleErrors(error);
          this.isLoading = false;
        }
      })
    }

  }
  

  private getFileData() {
    if (this.file_store.length > 0) {
      let fd = new FormData();
      fd.append("file", this.file_store[0], this.file_store[0].name);
      return fd;
    }

    return undefined;
  }


}
